<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'marital-status'"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- MARITAL STATUS GENERIC -->
      <form-row
        :label="`What is ${!isAdditional ? 'your' : 'their'} relationship status?`"
        :error="formObserver.validated && !observer.valid"
      >
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_marital-status`"
          name="Relationship Status"
          :rules="{
            required: true,
            is_not: { other: null }
          }"
        >
          <radio
            v-model="maritalStatusGenericModel"
            :name="`${stepId}.marital-status`"
            :data-test="fieldTrackerId.main"
            :items="maritalStatusGeneric"
            :error="failed"
            :error-messages="failed
              ? [`Please confirm ${!isAdditional ? 'your' : 'their'} relationship status.`]
              : []"
            column
            return-object
          />
        </validation-provider>

        <template
          v-if="helpText"
          #helpText
        >
          <div v-html="helpText" />
        </template>
      </form-row>
      <!-- MARITAL STATUS OTHER -->
      <form-row
        v-if="maritalStatusGenericModel !== null && !constants.MARITAL_STATUS_FAVORITES.includes(maritalStatusGenericModel)"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_marital-status`"
          name="Marital Status (Other)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.maritalStatus"
            :data-test="fieldTrackerId.other"
            :items="maritalStatusOther"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText(
              !isAdditional
                ? 'Please select your relationship status'
                : 'Please select their relationship status',
              isMobile
            )"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import QuestionBase from './Base';

export default {
  name: 'question-marital-status',
  extends: QuestionBase,
  data () {
    return {
      fields: ['maritalStatus'],
    };
  },
  computed: {
    maritalStatusGenericModel: {
      get () {
        if (this.questionData.maritalStatus === null) return null;
        return this.constants.MARITAL_STATUS_FAVORITES.includes(this.questionData.maritalStatus) ? this.questionData.maritalStatus : true;
      },
      set (val) {
        this.questionData.maritalStatus = val.logical ? val.logicalValue : val.value;
      },
    },
    maritalStatusGeneric () {
      return [
        ...this.helpers.createOptions({ source: pick(this.constants.MARITAL_STATUS, this.constants.MARITAL_STATUS_FAVORITES) }),
        this.constants.OTHER_OPTIONS,
      ];
    },
    maritalStatusOther () {
      return this.helpers.createOptions({ source: omit(this.constants.MARITAL_STATUS, this.constants.MARITAL_STATUS_FAVORITES) });
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.maritalStatus),
        other: `${snakeCase(this.questionFields.maritalStatus)}_other`,
      };
    },
  },
};
</script>
